import React from "react";

import siteguru from "../IMG/siteguru.jpeg";
import ecampus from "../IMG/ecampus.jpeg";
import u2opia from "../IMG/u2opialogo.jpeg";
import anjanitraders from "../IMG/anjnaiTraders.jpeg";

function Experience() {
  return (
    <>
      {/* SEO META TAGS (NO UI CHANGE) */}


      {/* UI — EXACTLY THE SAME */}
      <div className="pb-6 px-4">
        <div className="pb-4 md:pb-4 md:pt-4 px-6 pt-2 bg-white shadow-md rounded-md">
          <div>
            <h1 className="text-xl font-bold text-gray-800 my-4 tracking-wide">
              Experience
            </h1>

            <div className="space-y-6">
              {[
                {
                  img: u2opia,
                  roll: "Associate Software Engineer",
                  company: "U2opia Mobile",
                  duration: "May 2025 - Present",
                  location: "Gurugram, HR",
                  description: `Contribute to the development and maintenance of production-grade, real-time software systems used in large-scale environments.
Work across backend services and frontend workflows, supporting feature development, enhancements, and system improvements.
Collaborate closely with senior engineers and cross-functional teams to design, implement, and refine software components.
Follow Agile development practices, participating in sprint planning, code reviews, and continuous improvement initiatives.`,
                  stack:
                    "Java, Spring Boot, React.js, AWS, REST APIs, Microservices, Git",
                },
                {
                  img: siteguru,
                  roll: "Full-Stack Developer Intern",
                  company: "Edjobsync Enterprises (Site Guru)",
                  duration: "May 2024 - July 2024",
                  location: "Gurugram, HR",
                  description: `Delivered multiple production-ready web applications, contributing to faster project turnaround and improved delivery efficiency.
Designed and optimized database queries to improve execution time while ensuring data integrity and accuracy.
Improved application performance and responsiveness by optimizing frontend components and backend workflows.
Collaborated with cross-functional teams in an Agile environment to implement features, fix bugs, and support smooth deployments.`,
                  stack:
                    "Vue.js, Node.js, MySQL, JavaScript (ES6+), Vuetify, REST APIs, Git",
                },
                {
                  img: ecampus,
                  roll: "UI/UX Designer Intern",
                  company: "Edutra Technologies LLP",
                  duration: "June 2022 - August 2022",
                  location: "Noida, UP",
                  description: `Designed wireframes and high-fidelity mockups for LMS applications, aligning designs closely with product requirements and client expectations.
Collaborated with the design team to create intuitive, user-friendly interfaces, improving overall user engagement and usability.
Participated in user testing and design reviews, iterating on feedback to refine layouts, user flows, and interaction patterns.
Worked closely with developers to ensure design-to-implementation consistency.`,
                  stack:
                    "Figma, UX Research, Wireframing, Prototyping, User Testing",
                },
                {
                  img: anjanitraders,
                  roll: "Frontend Developer Intern",
                  company: "Anjani Traders",
                  duration: "June 2022 - August 2022",
                  location: "Prayagraj, UP (Remote)",
                  description: `Developed and enhanced responsive user interfaces using React.js, HTML5, and CSS.
Implemented clean, modular frontend components with a focus on usability, performance, and visual consistency.
Collaborated with team members to translate requirements into functional React-based UI components and deliver timely updates.
Assisted in improving overall user experience by refining layouts and ensuring smooth interactions.`,
                  stack:
                    "React.js, HTML5, CSS, Tailwind CSS, Responsive Design",
                },
              ].map((exp, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-4 p-5 bg-gray-50 rounded-md shadow-sm hover:shadow-md transition-all duration-200"
                >
                  <img
                    src={exp.img}
                    alt={`${exp.company} logo`}
                    className="w-14 rounded-md"
                  />

                  <div className="flex-1">
                    <h2 className="text-xl font-semibold text-gray-800">
                      {exp.roll}
                    </h2>

                    <p className="text-lg font-semibold text-gray-700">
                      {exp.company}
                    </p>

                    <p className="text-base text-gray-500 italic">
                      {exp.duration}
                    </p>

                    <p className="text-base text-gray-500">
                      Location: {exp.location}
                    </p>

                    <div className="text-base text-gray-500 mt-2">
                      <span className="font-semibold text-black">
                        Description
                      </span>
                      {exp.description.split("\n").map((line, i) => (
                        <span key={i} className="block">
                          {line.trim()}
                        </span>
                      ))}
                    </div>

                    <p className="text-base text-gray-500 mt-2">
                      <span className="font-semibold text-black">
                        Tech Stack:{" "}
                      </span>
                      {exp.stack}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Experience;
